import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { useParams } from "react-router";
import { Link } from "react-router-dom";

import TopAdd from "components/TopAdd";
import Topnav from "components/Topnav";
import RightAdd from "components/RightAdd";


import { getAccount, putAccount } from "services/account_service";
import { getTeamById } from "services/teams_service";

function App() {
  const { teamId } = useParams();
  const { playerId } = useParams();
  const navigate = useNavigate();

  const [player, setPlayer] = useState({});
  const [team, setTeam] = useState({});

  useEffect(() => {
    async function fetchData() {
      let playerBE = await getAccount(playerId);

      let teamBE = await getTeamById(teamId);

      setPlayer(playerBE);
      setTeam(teamBE);
    }

    fetchData();
  }, []);

  const submitForm = async () => {
    let newTeam = player.attributes.teams.data.filter((el) => el.id === teamId).map((el) => el.attributes.teams.data.id);
    await putAccount(playerId, { teams: newTeam });
    
    navigate(`/equipas/${teamId}`);
  };

  return (
    <div className="geral">
      <div className="App">
        <Topnav></Topnav>
        <div className="conteudo">
        <TopAdd></TopAdd>
        <div style={{"display": "flex"}}>

          <section className="section dashboard">
            <nav className="breadcrumb" aria-label="breadcrumbs">
              <ul>
                <Link to={"/equipas"}>Equipas</Link>/ Jogador / Detalhe
              </ul>
            </nav>

            <div className="geral">
              <div className="hero is-footsolution">
                <div className="columns">
                  <div className="column">
                    <h1 className="title is-3">Remover da equipa</h1>
                  </div>
                </div>
              </div>
            </div>

            <div className="columns">
              <div className="column">
                  <div className="block">
                    <div className="field">
                      Está a remover {player?.attributes?.name} da equipa{" "}.
                      Esta pessoa
                      não terá mais acesso nem verá informação da equipa{" "}
                      {team?.attributes?.name}. No entanto, a conta continuará a
                      existir na plataforma e poderá ser utilizada noutra
                      equipa.
                    </div>
                  </div>

                  <button onClick={() => submitForm()} className="button is-danger">Apagar</button>
              </div>
            </div>
          </section>
          <RightAdd></RightAdd>
         </div>
        </div>
      </div>
    </div>
  );
}

export default App;
